import { AdvertisingCatalogPage } from '../../../ui/advertising/AdvertisingCatalogPage/AdvertisingCatalogPage';
import { AdvertisingShops } from '../../../ui/advertising/AdvertisingShops/AdvertisingShops';
import { useTranslation } from '../../../utils/useTranslation';
import { useCpaShops } from './hooks/useCpaShops';

export const AdvertisingCatalogShops: React.FC<{}> = () => {
    const t = useTranslation();

    const {
        recomendationsShops,
        isRecomendationsShopsLoading,
        shops,
        isShopsLoading,
        shopSuggest,
        text,
        isSearchMode,
        onChangeText,
        onApplySuggest,
    } = useCpaShops();

    return (
        <AdvertisingCatalogPage
            title={t('Магазины')}
            titleContent={isSearchMode ? t('Результаты поиска') : t('Рекомендуемые магазины')}
            description={t(
                'Выберите магазин из рекомендаций или через поиск, перейдите на его сайт и выберите интересующий вас товар. Скопируйте ссылку на этот товар и вставьте её при создании своего поста.',
            )}
            searchPlaceholder={t('Поиск магазина')}
            searchValue={text}
            searchSuggest={shopSuggest}
            onApplySearchSuggest={onApplySuggest}
            onChangeSearchInput={onChangeText}
            key={isSearchMode ? 'search' : 'recomendations'}
        >
            <AdvertisingShops
                shops={isSearchMode ? shops : recomendationsShops}
                isLoading={isSearchMode ? isShopsLoading : isRecomendationsShopsLoading}
            />
        </AdvertisingCatalogPage>
    );
};
